<template>
  <div id="item_shop">
    <van-nav-bar
      :title="document_title"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-button type="default" round size="small" @click="onClickRight">{{ $t('column.My_props') }}</van-button>
      </template>
    </van-nav-bar>
    <van-row class="item_shop">
      <van-col span="22" offset="1" class="item_shop_type">
        <van-row gutter="20">
          <van-col span="6" v-for="(item,i) in shop_list" :key="i" @click.native="href(item.id)">
            <van-col span="24" class="item_shop_img">
              <img :src="item.img"/>
            </van-col>
            <van-col span="24" class="item_shop_name"> {{ item.title }} </van-col>
          </van-col>
        </van-row>
      </van-col>
      <van-col span="24" class="item_shop_list">
        <van-col span="22" offset="1" class="item_shop_list_div">
          <img src="../assets/img/recommend.png"/>
          <span>{{ $t('column.Popular') }}</span>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_list_center">
          <van-row gutter="20">
            <van-col span="8" v-for="(t,j) in car" :key="j" @click.native="shop_show_btn(t,1)">
              <van-col span="24" class="item_shop_list_center_one">
                <van-col span="24" class="item_shop_list_center_one_img">
                  <img :src="t.img"/>
                </van-col>
                <van-col span="24" class="item_shop_list_center_one_title">{{ t.name }}</van-col>
                <van-col span="24" class="item_shop_list_center_one_coin">
                  <img :src="coin_img"/>
                  <span>{{ t.coin }}/{{ t.day }} {{ $t('other.days') }}</span>
                </van-col>
              </van-col>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_list_div">
          <img src="../assets/img/recommend.png"/>
          <span>{{ $t('column.Popular') }}</span>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_list_center">
          <van-row gutter="20">
            <van-col span="8" v-for="(ta,i) in avatar_frame" :key="i" @click.native="shop_show_btn(ta,2)">
              <van-col span="24" class="item_shop_list_center_one">
                <van-col span="24" class="item_shop_list_avatar_frame_img">
                  <img :src="head_image"/>
                  <div :id='"popular_svga"+ta.id' class="item_shop_list_avatar_frame_svga"></div>
                </van-col>
                <van-col span="24" class="item_shop_list_center_one_title">{{ ta.name }}</van-col>
                <van-col span="24" class="item_shop_list_center_one_coin">
                  <img :src="coin_img"/>
                  <span>{{ ta.coin }}/{{ ta.day }} {{ $t('other.days') }}</span>
                </van-col>
              </van-col>
            </van-col>
          </van-row>
        </van-col>
      </van-col>
      <van-popup v-model="shop_show" round position="bottom" :style="{ height: '40%' }" >
        <van-col span="24" class="item_shop_popup" @click.native="car_play(buy_one.svga)" v-if="buy_one.shop_type === 1">
          <van-icon name="play-circle-o" class="item_shop_popup_icon"/>
          <img :src="buy_one.img"/>
        </van-col>
        <van-col span="24" class="item_shop_popup item_shop_list_avatar_frame_popup_img" v-else>
            <img :src="head_image"/>
            <div :id='"popup_popular_svga"+buy_one.id' class="item_shop_list_avatar_frame_popup_svga"></div>
        </van-col>
        <van-col span="22" offset="1">
          <van-col span="12" class="item_shop_popup_left">{{ buy_one.name }}</van-col>
          <van-col span="12" class="item_shop_popup_right">
            <img :src="coin_img"/>
            {{ buy_one.coin }}/{{ buy_one.day }} {{ $t('other.days') }}
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_popup_btn">
          <van-button round color="#AE2CF1" block  @click="car_btn"> {{ buy_one.is_renew ?  buy_one.time + ' ' + this.$t('other.expire') +',' + this.$t('Tips.Whether_to_renew') : $t('btn.purchase') }}</van-button>
        </van-col>
      </van-popup>
      <van-overlay :show="svgaShow" @click.native="svgaHide" class="car_svga_index">
        <div id="svgaBox" @click.stop="svgaHide"></div>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog } from 'vant'
import SVGA from "svgaplayerweb";
export default {
  data() {
    return {
      shop_list: [
        { id:1, title: this.$t('column.Car'), 'img': require('../assets/img/item_shop_car.png')},
        { id:2, title: this.$t('column.avatar_frame'), 'img': require('../assets/img/avatar_frame.png')},
        { id:3, title: this.$t('column.beautiful_horn'), 'img': require('../assets/img/beautiful_horn.png')},
        { id:4, title: this.$t('column.VIP_members'), 'img': require('../assets/img/VIP_members.png')},
      ],
      document_title: '',
      car: [],
      avatar_frame: [],
      svgaShow: false,
      shop_show: false,
      buy_one: {},
      coin_img: '',
      is_submit: true,
      head_image: ''
    }
  },
  created: function() {
    this.convert();
    this.document_title = this.$t('title.shop')
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    href(id) {
      let url =''
      if (id === 1) {
        url='/item_shop_car'
      } else if (id === 2) {
        url='/item_shop_avatar'
      } else if(id === 3) {
        url='/item_shop_lucky'
      } else {
        url='/item_shop_vip'
      }
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: url, query: {uid: uid, token: token}})
    },
    SVGA() {
      this.$nextTick(()=>{
        this.avatar_frame.map((v,i)=>{
          //这里动态给ID，列表
          var player = new SVGA.Player('#popular_svga'+v.id);
          var parser = new SVGA.Parser('#popular_svga'+v.id);
          //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
          parser.load(v.img, function(videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          })
        })
      })
    },
    popup_popular_svga() {
      const val = this.buy_one
      console.log('dddddd')
      console.log(val)
      this.$nextTick(()=>{
        //这里动态给ID，列表
        const player1 = new SVGA.Player('#popup_popular_svga' + val.id);
        const parser1 = new SVGA.Parser('#popup_popular_svga' + val.id);
        console.log(val.img)
        //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
        parser1.load(val.img, function(videoItem1) {
          player1.setVideoItem(videoItem1);
          player1.startAnimation();
        })
      })
    },
    shop_show_btn(t,type) {
      this.buy_one = t
      this.buy_one.pay_id = 0;
      this.buy_one.time = 0;
      this.buy_one.is_renew = 0;
      this.buy_one.shop_type = type; // 1座驾 2头像框
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=select_coin", {
        params: {
          user_id: uid,
          token: token,
          id: this.buy_one.id,
          type: type
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.buy_one.time = res.data.list.time
          this.buy_one.pay_id = res.data.list.id
          this.buy_one.is_renew = res.data.list.is_renew;
          this.shop_show = true
          if(this.buy_one.shop_type === 2){
            this.popup_popular_svga()
          }
        } else {
          Toast(res.data.error)
        }
      })
    },
    svgaHide() {
      this.svgaShow = false
    },
    car_btn() {
      if (this.is_submit === false) {
        return false
      }
      this.is_submit = false
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=pay", {
        params: {
          user_id: uid,
          token: token,
          id: this.buy_one.pay_id,
          shop_id: this.buy_one.id,
          shop_type: this.buy_one.shop_type
        }
      }).then(res => {
        this.is_submit = true
        console.log(res.data)
        this.shop_show = false
        Toast(res.data.error)
      })
    },
    car_play(url) {
      this.svgaShow = true
      const _this= this
      this.$nextTick(() => {
        try {
          const player = new SVGA.Player('#svgaBox');
          const parser = new SVGA.Parser('#svgaBox');
          //注意，这里必须是服务器地址，否则报错
          parser.load(url, function(videoItem) {
            player.loops = 1;  // 设置循环播放次数是1
            player.setVideoItem(videoItem);
            player.startAnimation();
            player.onFinished(function(){
              _this.svgaShow = false
            });
          })
        } catch (error) {
          console.error(error);
        }
      })
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogogame://exit"
    },
    onClickRight() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path: '/item_shop_my', query: {uid: uid, token: token}})
    },
    convert() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=index", {
        params : {
          user_id: uid,
          token: token
        }
      }).then(res =>{
        console.log(res.data)
        this.car = res.data.data.car
        this.avatar_frame = res.data.data.avatar_frame
        this.diamonds_name = res.data.data.diamonds_name
        this.coin_img = res.data.data.consumer_price_Icon
        this.head_image = res.data.data.head_image
        this.SVGA()
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/item_shop.vue